import React, { useEffect, useState } from 'react';
import { PrimaryButton } from '../components/button';
import { Constants } from '../lib/const/constants';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { encryptPayload } from '../utils/encryption';

const MOCK_OFFICERS = [
  {
    name: "Emma Johnson",
    officer_role: "Director",
    nationality: "British",
    country_of_residence: "United Kingdom",
    occupation: "Finance Manager",
    address: {
      locality: "London",
      region: "Greater London",
      address_line_1: "221B Baker Street",
      postal_code: "NW1 6XE",
    },
    date_of_birth: { month: "07", year: "1984" },
    appointed_on: "2019-03-15",
  },
  {
    name: "Liam Patel",
    officer_role: "Secretary",
    nationality: "British",
    country_of_residence: "United Kingdom",
    occupation: "Company Secretary",
    address: {
      locality: "Manchester",
      region: "Greater Manchester",
      address_line_1: "10 King Street",
      postal_code: "M2 6AG",
    },
    date_of_birth: { month: "11", year: "1990" },
    appointed_on: "2020-06-01",
  },
  {
    name: "Olivia Chen",
    officer_role: "Director",
    nationality: "British",
    country_of_residence: "United Kingdom",
    occupation: "Operations Lead",
    address: {
      locality: "Birmingham",
      region: "West Midlands",
      address_line_1: "3 Highfield Road",
      postal_code: "B15 3DP",
    },
    date_of_birth: { month: "02", year: "1988" },
    appointed_on: "2021-01-20",
  },
];

export default function SelectOfficer() {
  const navigate = useNavigate();
  const [buttonLoading, setButtonLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  const [firstName, setfirstName] = useState("");
  const [lastName, setlastName] = useState("");
  const [dateOfBirth, setdateOfBirth] = useState("");
  const [role, setrole] = useState("");
  const [joiningDate, setjoiningDate] = useState("");

  const [selectedOfficer, setselectedOfficer] = useState(null);
  const [data, setData] = useState([]);

  const submitData = async () => {
    if (selectedOfficer === null) {
      toast.error("Please select an officer to continue.");
      return;
    }

    try {
      setButtonLoading(true);
      const token = sessionStorage.getItem('registrationToken');
      const deviceId = sessionStorage.getItem('deviceid');
      const userid = sessionStorage.getItem('userid');
      const businessEmail = sessionStorage.getItem('businessEmail');
      const businessPhone = sessionStorage.getItem('businessPhone');
      const encryptedPayload = await encryptPayload({
          officers: [
            {
              first_name: firstName,
              last_name: lastName,
              email: businessEmail,
              mobile: businessPhone,
              date_of_birth: dateOfBirth, // e.g., "07-1984"
              role: role,
              meta: { joining_date: joiningDate, resign_date: null },
              share: null,
              is_registered: true,
              is_first_officer: null,
            },
          ],
          platform: 'web',
          extraParamValidation: 'trustedfromweb'
        });
      await axios.post(
        Constants.BASE_URL + "API-FX-178-BUSINESS-REGISTRATION-COMPANY-OFFICERS",
        encryptedPayload,
        { headers: { fx_key: Constants.SUBSCRIPTION_KEY, Authorization: 'Bearer ' + token } }
      );

      const dropencryptedPayload = await encryptPayload({
          screen_name: "SELECT_OFFICER_9",
          meta: { firstName, lastName, dateOfBirth, role, joiningDate },
          device_id: deviceId,
          user_id: userid,
        });
      await axios.post(
        Constants.BASE_URL + "API-FX-159-DROPSCREEN",
        dropencryptedPayload,
        { headers: { fx_key: Constants.SUBSCRIPTION_KEY } }
      );

      navigate('/ApplicationPreview');
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong");
    } finally {
      setButtonLoading(false);
    }
  };

  const loadData = async () => {
    setLoading(true);
    const token = sessionStorage.getItem('registrationToken');
    const regNumber = sessionStorage.getItem('selectedcompanyNumber');

    try {
      const resp = await axios.get(
        Constants.BASE_URL + "API-FX-170-COMPANY-OFFICERS?number=" + regNumber,
        { headers: { fx_key: Constants.SUBSCRIPTION_KEY, Authorization: 'Bearer ' + token } }
      );

      const list = resp?.data?.data ?? [];
      if (Array.isArray(list) && list.length > 0) {
        setData(list);
      } else {
        // Fallback to mock data for UI work
        setData(MOCK_OFFICERS);
      }
    } catch (err) {
      // Fallback to mock data if API fails
      setData(MOCK_OFFICERS);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const handleSelect = (item, index) => {
    setselectedOfficer(index);
    setfirstName(item?.first_name || item?.name?.split(' ')?.[0] || "");
    setlastName(item?.last_name || item?.name?.split(' ')?.slice(1).join(' ') || "");
    if (item?.date_of_birth) {
      const m = item.date_of_birth.month ?? "";
      const y = item.date_of_birth.year ?? "";
      setdateOfBirth(`${m}-${y}`); 
    } else {
      setdateOfBirth("");
    }
    setrole(item?.officer_role || "");
    setjoiningDate(item?.appointed_on || "");
  };

return (
  <div className="min-h-screen w-full bg-white flex flex-col">
    {/* Top bar */}
    <div className="w-full border-b border-[#0B214E33] py-6 px-6">
      <img src="/fx_logo_old.png" alt="FXMaster Logo" className="w-[160px]" />
    </div>

    <ToastContainer />

    <div className="flex flex-1 items-start justify-center px-4 py-6">
      <div className="w-full max-w-[720px] mx-auto">
        {/* Back + Title */}
        <div
          className="flex items-center mb-4 pt-1 cursor-pointer gap-2"
          onClick={() => navigate("/AboutBusiness")}
        >
          <div className="flex items-center gap-[4px]">
  <img src="./arrow-left.svg" alt="back" />
  <span className="text-lg font-bold text-[#0B214E]">Select Officer</span>
</div>
        </div>

        {/* Loading */}
        {loading && <div className="mb-4 text-sm text-gray-600">Loading…</div>}

        {/* Officer list */}
        <div
          className="w-full max-w-[720px] pr-2"
          style={{ maxHeight: '55vh', overflowY: 'auto' }}
        >
          {data.map((item, index) => {
            const isSelected = selectedOfficer === index;

            const topAddress = [
              item?.address?.address_line_1,
              item?.address?.locality,
              item?.address?.postal_code,
            ].filter(Boolean).join(', ') || '—';

            const appointed = item?.appointed_on
              ? new Date(item.appointed_on).toLocaleDateString('en-GB', {
                  day: '2-digit',
                  month: 'long',
                  year: 'numeric',
                })
              : '—';

            const nationality = item?.nationality || '—';
            const residence   = item?.country_of_residence || '—';
            const occupation  = item?.occupation || '—';
            const corrAddress = topAddress;

            return (
              <div
                key={index}
                role="button"
                tabIndex={0}
                onClick={() => handleSelect(item, index)}
                onKeyDown={(e) =>
                  (e.key === 'Enter' || e.key === ' ') && handleSelect(item, index)
                }
                className={`relative mb-5 w-full rounded-xl bg-white p-5 shadow-sm border ${
                  isSelected ? 'border-[#0B214E]' : 'border-[#0B214E]'
                }`}
              >
                {/* radio (top-right) */}
                <div className="absolute top-4 right-4" onClick={(e) => e.stopPropagation()}>
  <label className="inline-flex items-center cursor-pointer select-none">
    <input
      type="radio"
      name="officer"
      className="peer sr-only"
      checked={isSelected}
      onChange={() => handleSelect(item, index)}
      aria-label="Select this officer"
    />
    <span
      className="
        w-5 h-5 rounded-full grid place-content-center transition-colors
        border border-[#C4C6C1] bg-white
        peer-checked:bg-[#0B214E] peer-checked:border-[#0B214E]
      "
    >
      <img
        src="./icons/tick-icon-active.svg"  
        alt=""
        className="w-3 h-3 peer-checked:opacity-100 transition-opacity"
      />
    </span>
  </label>
</div>


                {/* header: name, phone/status, address */}
                <div className="text-center text-[#0B214E]">
                  <div className="text-[16px] text-[#000000] font-semibold">
                    {item?.name} {item?.officer_role ? `– ${item.officer_role}` : ''}
                  </div>

                  <div className="mt-1 flex items-center justify-center gap-2 text-sm">
                    <span>{item?.phone || item?.mobile || '—'}</span>
                    <span className="px-2 py-[2px] text-xs rounded-full bg-[#86F135] text-[#2F5711] font-semibold">
                      Active
                    </span>
                  </div>

                  <div className="mt-1 text-sm">{topAddress}</div>
                </div>

                {/* dotted divider */}
                <div className="my-3 border-b border-dashed border-[#205FFF]" />

                {/* two-column facts */}
                <div className="grid grid-cols-2 gap-y-4 text-[#0B214E]">
                  <div>
                    <div className="font-semibold text-sm text-[#000000]">{appointed}</div>
                    <div className="text-xs text-[#454745]">Appointed on</div>
                  </div>
                  <div className="text-right">
                    <div className="font-semibold text-sm text-[#000000]">{nationality}</div>
                    <div className="text-xs text-[#454745]">Nationality</div>
                  </div>

                  <div>
                    <div className="font-semibold text-sm text-[#000000]">{residence}</div>
                    <div className="text-xs text-[#454745]">Country of residence</div>
                  </div>
                  <div className="text-right">
                    <div className="font-semibold text-sm text-[#000000]">{occupation}</div>
                    <div className="text-xs text-[#454745]">Occupation</div>
                  </div>
                </div>

                <div className="mt-4">
                  <div className="font-semibold text-sm text-[#000000]">{corrAddress}</div>
                  <div className="text-xs text-[#454745]">Correspondence address</div>
                </div>
              </div>
            );
          })}

          {!loading && data.length === 0 && (
            <div className="text-sm text-gray-500">No officers found.</div>
          )}
        </div>

        {/* Continue */}
        <div className="w-full max-w-[720px] mt-4">
          <PrimaryButton onClick={submitData} label={"Continue"} loading={buttonLoading} />
        </div>
      </div>
    </div>
  </div>
);


}
